import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	editShortcut: {
		id: 'navigation-shortcuts.edit-shortcut-modal.edit-shortcut',
		defaultMessage: 'Edit shortcut',
		description: '',
	},
	deleteButton: {
		id: 'navigation-shortcuts.edit-shortcut-modal.delete-button',
		defaultMessage: 'Delete',
		description: '',
	},
	removeShortcut: {
		id: 'navigation-shortcuts.edit-shortcut-modal.remove-shortcut',
		defaultMessage: 'Remove shortcut',
		description: '',
	},
	editButton: {
		id: 'navigation-shortcuts.edit-shortcut-modal.edit-button',
		defaultMessage: 'Update',
		description: '',
	},
	closeButton: {
		id: 'navigation-shortcuts.edit-shortcut-modal.close-button',
		defaultMessage: 'Close',
		description: '',
	},
	cancelButton: {
		id: 'navigation-shortcuts.edit-shortcut-modal.cancel-button',
		defaultMessage: 'Cancel',
		description: '',
	},
});
